import { useState } from "react";
import { SCHOOL_PITCH_VIDEO_IDS } from "../constants";
import { useSchoolLocal } from "../useSchoolLocal";

const PlayIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M8 5v14l11-7z" />
  </svg>
);

// Shows a poster until clicked, so YouTube only loads for visitors who watch.
export const PitchVideo = () => {
  const { t, language } = useSchoolLocal();
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = SCHOOL_PITCH_VIDEO_IDS[language];
  const thumbnailUrl = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-2xl bg-[#F8F8F8] shadow-[0_12px_40px_rgba(26,31,54,0.08)]">
      {isPlaying ? (
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
          title={t("hero.videoTitle")}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          onClick={() => setIsPlaying(true)}
          aria-label={t("hero.playVideo")}
          className="group absolute inset-0 h-full w-full"
        >
          <img
            src={thumbnailUrl}
            alt=""
            // YouTube thumbnails have thin black bars on the top and bottom edges; zoom past them.
            className="h-full w-full scale-[1.03] object-cover"
          />
          <span className="absolute inset-0 m-auto grid h-[72px] w-[72px] place-items-center rounded-full bg-[#4242CE] text-white shadow-[0_12px_30px_rgba(66,66,206,0.4)] transition-transform duration-200 group-hover:scale-105">
            <PlayIcon />
          </span>
          <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/55 to-transparent px-5 py-4 text-start text-[13px] font-semibold text-white">
            {t("hero.videoCaption")}
          </span>
        </button>
      )}
    </div>
  );
};
